export enum Layout {
  VERTICAL = 'VERTICAL',
  VERTICAL_TWO_COLUMN = 'VERTICAL_TWO_COLUMN',
  VERTICAL_ONE_COLUMN = 'VERTICAL_ONE_COLUMN',
  HORIZONTAL = 'HORIZONTAL',
  HORIZONTAL_JUSTIFIED = 'HORIZONTAL_JUSTIFIED',
  HORIZONTAL_LEFT_ALIGNED = 'HORIZONTAL_LEFT_ALIGNED',
  HORIZONTAL_RIGHT_ALIGNED = 'HORIZONTAL_RIGHT_ALIGNED',
}
